import validate from "/usr/src/app/content/n3-spas-a5de39d0-e53d-498a-ae70-4258dd46aa71/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-a5de39d0-e53d-498a-ae70-4258dd46aa71/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}